// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"123":"d35309ea54f8a921","917":"f94f1b0c9b0d716b"}[chunkId] + ".js";
};